import styled from 'styled-components';

export const AreaSubIcon = styled.div`
  position: absolute;
  left: 0px;
  display: flex;
  flex-direction: column;
  min-height: 89vh;
  background: #101010;

  div {
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  svg {
    height: 30px;
    width: 30px;
    fill: #60687d;
  }

  svg:hover, .on svg {
    fill: #fff;
  }
`